module.exports = __webpack_public_path__ + "img/monitor_5.5a1f746b.png";